import { useEffect } from 'react'
import { SubTitlePage } from "../../../components/ui/SubTitlePage";
import '@fancyapps/ui/dist/fancybox/fancybox.css'
import { Fancybox } from '@fancyapps/ui'
import { Download } from 'lucide-react';

interface Props {
	gallery: string[]
	download: string
}

export function ListImages({ gallery, download }: Props) {
	useEffect(() => {
		Fancybox.bind('[data-fancybox="gallery"]')
	}, [gallery])

	return (
		<div className="w-full font-roboto">
			<SubTitlePage title="Imagens Relacionadas" />

			<div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mt-3 mb-4">
				{gallery.map((item, index) => {
					const imageName = item.split('/').pop()
					const baseUrl = 'https://api-portal.itajai.sc.gov.br/public/portaladm-pmitajai/noticias/'
					const imgOriginal = `${baseUrl}original/${imageName}`

					if (item === `${baseUrl}foto/.jpg`) return null

					return (
						<a
							key={imageName}
							href={imgOriginal}
							data-fancybox="gallery"
							data-src={imgOriginal}
							className="block cursor-pointer overflow-hidden rounded-xl lg:rounded-lg group"
						>
							<img
								src={imgOriginal}
								className="w-full h-32 lg:h-40 object-cover transition-transform duration-300 group-hover:scale-105 dark:opacity-90 dark:hover:opacity-100"
								alt={`Imagem ${index + 1}`}
								loading="lazy"
							/>
						</a>
					)
				})}
			</div>

			{!!download && (
				<a
					href={download}
					target="_blank"
					rel="noreferrer"
					className="flex items-center justify-center gap-2 w-full py-3 bg-primary dark:bg-primary-light text-white rounded-xl font-semibold text-sm uppercase tracking-wider no-underline transition-all duration-200 hover:bg-primary-dark dark:hover:bg-primary mb-6"
				>
					<Download size={16} />
					Fazer download das imagens
				</a>
			)}
		</div>
	)
}